import { useStateSelector } from '../../store/selectors';
import { VenueId } from '../../venues/venues.types';

export const useSelectedVenueId = (): VenueId | null =>
    useStateSelector((s) => s.venue.selectedVenue);
